export default __webpack_public_path__ + "7b38a7982aeb5d8900687b6e6f6d008a.webp";